import { OnInit, Output, EventEmitter } from '@angular/core';
import { Component, Inject, forwardRef } from '@angular/core';
import { AppComponent } from './app.component';
import { PadraoService } from './service/padrao.service';
import { SelectItem } from 'primeng/components/common/selectitem';
import { ObservableLotacao, bObservableUsuario } from 'app/util/observable-util';
import { Router } from '../../node_modules/@angular/router';
import { Observable } from '../../node_modules/rxjs';
import { ConfirmationService } from 'primeng/primeng';
import { JwtHelper } from "angular2-jwt";
import { environment } from '../environments/environment';
import * as FileSaver from 'file-saver';
import { DatatableService, DataProviderFactory } from '@basis/angular-components';
import { Http } from '@angular/http';

@Component({
    selector: 'app-topbar',
    template: `
    <div class="topbar clearfix">
        <div id="novo1" class="topEsquerdo">
            <span *ngIf="listaLotacao.length > 0">
            <div [ngStyle]="setStyles()" id="imagemLogoLotacao"></div>  
            <span class="md-inputfield-2 select_sistema" style="color: #0e3e67; text-align: center; left: 40px; top: 46px; position: absolute;">
                <p-dropdown class="ui-dropdown-label" id="lotacaoDDL" [(ngModel)]="id_lotacao" name="lotacaoDDL" (onChange)="onChangeLotacao($event)" [options]="listaLotacao | formatSelectItemTopBar:'id':'sigla' " [autoWidth]="true" placeholder="Selecione a Lotação...">
                    <ng-template let-item pTemplate="selectedItem">
                        {{ "" }}
                    </ng-template>
                </p-dropdown>
            </span>
            </span>
        </div>
        
        <div class="topbar-right">
            <a id="menu-button" href="#" (click)="app.onMenuButtonClick($event)">
                <i></i>
            </a>

            <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
                <i class="material-icons">menu</i>
            </a>

            <ul class="topbar-items animated fadeInDown" [ngClass]="{'topbar-items-visible': app.topbarMenuActive}">
                <li #profile class="profile-item" *ngIf="usuario != null"
                    [ngClass]="{'active-top-menu':app.activeTopbarItem === profile}">

                    <a href="#" (click)="app.onTopbarItemClick($event,profile)" style="color:white;text-align:center;line-height: 12px;">
                        <div>
                            <i class="material-icons">person</i>
                            <br>
                            <span> {{ usuario?.nome }} </span>
                            <span *ngIf="!usuario.nome"> {{usuario?.cpf}} </span>
                            <br>

                            <span style="font-size:8pt"> {{usuarioSimulado}} </span>
                        </div>
                    </a>

                    <ul class="ultima-menu animated fadeInDown">
                        <li role="menuitem">
                            <a href="#" (click)="service.Logout()">
                                <i class="material-icons">power_settings_new</i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

            <div *ngIf="usuario != null" class="topbar-items animated fadeInDown" style="color:white;text-align:center;font-size: 15px; line-height: 15px; padding-right: 50px;">       
                <i class="material-icons">access_time</i>
                <br>  
                <span>Tempo de Sessão: {{tempoExpFormatado}}</span>
            </div>
            <div *ngIf="usuario != null" class="topbar-items animated fadeInDown" style="color:white;text-align:center;font-size: 15px; line-height: 15px; padding-right: 10px;">    
                <a href="#" (click)="manual()" style="color:white;text-align:center;font-size: 15px; line-height: 15px; padding-right: 50px;" title="Ajuda online">
                    <i class="material-icons">help_outline</i>
                </a>
                <br>
            </div>
            <a *ngIf="usuario != null" class="topbar-items animated fadeInDown nome_sistema">
                <i class="material-icons">contact_mail</i>
                <h1 class="texto_sistema">Registro</h1>
            </a>
        </div>
    </div>
    `,
    styleUrls: ["app.topbar.component.css"]
})
export class AppTopBar {

    timeToExpireToken: any = -1;
    tempoExpFormatado: any = "00:00:00";
    usuario: any;
    contagemTokenIniciada: any = false;
    dialogEmitted: boolean = false;
    id_lotacao: any = '';
    listaLotacao: any[] = [];
    usuarioSimulado: string = null;
    cpfSimulado: string = null;
    funcionalidadesPublicas: string[] = ['#/consultas/consulta-cnaipj', '#/documentos/certidao-cnaipj', '#/documentos/validar-documentos'];

    @Output() emitDialog = new EventEmitter<boolean>();

    constructor(
        @Inject(forwardRef(() => AppComponent))
        public app: AppComponent,
        private service: PadraoService,
        private lotacaoService: ObservableLotacao,
        private usuarioSessao: bObservableUsuario,
        private router: Router,
        private jwtHelper: JwtHelper) {

        this.lotacaoService.setLotacao(Object.assign({}, null, { isLoaded: false }))
        let rota = window.location.hash

        if (localStorage.getItem("token") != null && !window.frameElement) {
            // this.service.Lotacoes().subscribe(data => this.listaLotacao = data);
            this.usuarioSessao.getValue.subscribe(data => {
                if (data) {
                    if (this.contagemTokenIniciada == false && !this.jwtHelper.isTokenExpired(localStorage.getItem("token"))) {
                        this.obterTimeToExpireToken();
                        this.contagemToken();
                    }
                    this.usuario = data.obj;
                    this.listaLotacao = this.usuario.lotacaoDTO;
                    if (this.listaLotacao.every(x => x.nome == 'Lotação Pública')) {
                        localStorage.setItem('path', this.usuario.lotacaoDTO[0].anexoLotacao[0].nomeUpload);
                        this.service.ObterLogoLotacao('acessos', this.usuario.lotacaoDTO[0].anexoLotacao[0].nomeUpload).subscribe(data => {
                            var objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
                            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
                        });
                        localStorage.setItem('lotacao', this.usuario.lotacaoDTO[0].id);
                    } else if (localStorage.getItem('lotacao') == '' || localStorage.getItem('lotacao') == null) {
                        this.id_lotacao = this.usuario.lotacaoDTO[0].id;
                        localStorage.setItem('path', this.usuario.lotacaoDTO[0].anexoLotacao[0].nomeUpload);
                        this.service.ObterLogoLotacao('acessos', this.usuario.lotacaoDTO[0].anexoLotacao[0].nomeUpload).subscribe(data => {
                            var objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
                            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
                        });
                        localStorage.setItem('lotacao', this.id_lotacao);
                    } else {
                        this.id_lotacao = localStorage.getItem('lotacao');
                        var lot = this.listaLotacao.find(x => x.id == this.id_lotacao);
                        this.service.ObterLogoLotacao('acessos', lot.anexoLotacao[0].nomeUpload).subscribe(data => {
                            var objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
                            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
                        });
                    }
                    this.lotacaoService.setLotacao(Object.assign({}, this.listaLotacao.find(x => x['id'] == localStorage.getItem('lotacao')), { isLoaded: true }));

                    this.listaLotacao = this.listaLotacao.filter(x => x.nome != 'Lotação Pública');

                    service.SimularUsuario(this.usuario.cpf).subscribe(dadosDeSimulacao => {
                        const possuiUsuarioParaSimulacao = dadosDeSimulacao.length > 0;
                        const construirDadosCabeçalho = possuiUsuarioParaSimulacao ?
                            this.usuario.nome === dadosDeSimulacao[0].usuario1.nome : false;

                        if (!possuiUsuarioParaSimulacao) {
                            localStorage.removeItem('simulacaoEmAndamento');
                        }

                        if (possuiUsuarioParaSimulacao && construirDadosCabeçalho) {
                            this.usuarioSimulado = 'Usuário Simulado: ' + dadosDeSimulacao[0].usuario.nome;
                            this.cpfSimulado = dadosDeSimulacao[0].usuario.cpf;
                        }
                    });
                }
            });
        }
        else if (localStorage.getItem("token") == null && this.funcionalidadesPublicas.filter(f => rota.includes(f)).length > 0) {
            this.service.ObterLogoCfc().subscribe(data => {
                var objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
                document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
            });
        }
    }

    contagemToken() {
        this.contagemTokenIniciada = true;
        Observable.interval(1000)
            .subscribe(i => {
                if (localStorage.getItem("timeExpToken") && !this.jwtHelper.isTokenExpired(localStorage.getItem("token"))) {
                    this.timeToExpireToken = localStorage.getItem("timeExpToken");
                    this.timeToExpireToken = +this.timeToExpireToken + 60;
                    localStorage.removeItem("timeExpToken");
                }
                if (this.jwtHelper.isTokenExpired(localStorage.getItem("token")) && this.timeToExpireToken == 0) {
                    this.contagemTokenIniciada = false;
                    this.emitDialog.emit(true);
                    // setTimeout(() => { this.emitDialog.emit(true); }, 2000);
                } else {
                    if (this.timeToExpireToken > 0) {
                        this.timeToExpireToken = this.timeToExpireToken - 1;
                        var date = new Date(null);
                        date.setSeconds(this.timeToExpireToken);
                        this.tempoExpFormatado = date.toISOString().substr(11, 8);
                    }
                }
            });
    }

    obterTimeToExpireToken() {
        this.service.ObterTokenDecodificado().subscribe(time => {
            localStorage.setItem("timeExpToken", time);
        });
    }

    reiniciarContagemToken() {
        this.obterTimeToExpireToken();
        this.contagemToken();
    }

    onChangeLotacao(lotacao: any): void {
        localStorage.setItem('lotacao', this.id_lotacao);
        this.router.navigate(['../']);
        this.lotacaoService.setLotacao(Object.assign({}, this.listaLotacao.find(x => x['id'] == localStorage.getItem('lotacao')), { isLoaded: true }))
        var lot = this.listaLotacao.find(x => x.id == this.id_lotacao);
        localStorage.setItem('path', lot.anexoLotacao[0].nomeUpload);
        this.service.ObterLogoLotacao('acessos', localStorage.getItem("path")).subscribe(data => {
            var objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
        });
        // window.location.reload(true);
    }

    setStyles() {
        let styles = {
            'display': 'inline-block',
            'vertical-align': 'middle',
            'width': '180px',
            'height': '70px',
            'background': 'top left no-repeat',
            'background-size': '130px 55px',
            'margin-left': '50px'
        };
        return styles;
    }
    b64toFile(b64Data, filename, contentType) {
        var sliceSize = 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);

            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var file = new File(byteArrays, filename, { type: contentType });
        return file;
    }

    manual() {
        this.service.requisicaoManual().subscribe(pdf => {
            FileSaver.saveAs(this.b64toFile(pdf, `Manual Sistema Registro`, 'application/octet-stram'), `Manual_Sistema_Registro.pdf`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/app.topbar.component.ts